const defaultFormState = {
  number: '+1',
  assignedTo: '',
  company: '',
  allowedUsers: [],
  huntPorts: [],
};

const numberFormState = (state = defaultFormState, action) => {
  let object = {};
  if (action.value === 'ringDown') {
    object = {
      ...state,
      forwardUris: [],
      ...{ [action.name]: action.value },
    };
  } else {
    object = {
      ...state,
      ...{ [action.name]: action.value },
    };
  }
  if (action.name==="type") {
    object["forwardUris"] = []
  }
  switch (action.type) {
    case 'EDIT_NUMBER_SHOW': {
      const { number } = action;
      return { ...number };
    }
    case 'EDIT_BOX_NUMBER_SHOW': {
      const { number } = action;
      return { ...number };
    }
    case 'EDIT_NUMBER_FIELD_CHANGE':
      return object;
    case 'EDIT_NUMBER_FIELD':
      return { ...action.value };
    case 'EDIT_NUMBER_SUCCESS':
    case 'UPDATE_NUMBER_SUCCESS':
    case 'EDIT_NUMBER_CANCEL':
      return defaultFormState;
    default:
      return state;
  }
};

export default numberFormState;
